// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"e3-z","upvote":"f3-z","downvote":"g3-z","numVotes":"h3-z","votesDescription":"i3-z","report":"j3-z","voted":"k3-z","answerVoteBox":"l3-z","justReported":"m3-z"};